import React from 'react'
import styles from './styles.module.css'
import GanttChart from './components/ganttChart/GanttChart'
import PropTypes from 'prop-types'

const ReactPlanner = ({
  shifts,
  handleDragEvent,
  tasks,
  setTasks,
  resources,
  setResources
}) => {
  return (
    <GanttChart
      shifts={shifts}
      handleDragEvent={handleDragEvent}
      tasks={tasks}
      setTasks={setTasks}
      resources={resources}
      setResources={setResources}
    />
  )
}
ReactPlanner.defaultProps = {
  shifts: 4,
  tasks: [],
  resources: []
}

ReactPlanner.propTypes = {
  shifts: PropTypes.number,
  tasks: PropTypes.array,
  resources: PropTypes.array
}
export default ReactPlanner
